import React from 'react';
import SEO from '../components/SEO';

const Terms: React.FC = () => {
  return (
    <>
      <SEO
        title="Terms & Conditions - GameObsidian"
        description="Read the terms and conditions for using GameObsidian. Understand your rights and responsibilities when using our website."
        url="/terms"
      />

      <div className="min-h-screen pt-20 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-6xl font-bold mb-8">
            Terms & <span className="text-gradient">Conditions</span>
          </h1>
          <p className="text-dark-muted mb-8">Last updated: December 2025</p>

          <div className="glass-effect rounded-2xl p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                By accessing and using GameObsidian.com ("the Website"), you accept and agree to be 
                bound by the terms and provision of this agreement. If you do not agree to these terms, 
                you should not use this website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">2. Age Restriction</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                You must be at least 18 years old to use this website. By using this website, you 
                represent and warrant that you are at least 18 years of age and have the legal capacity 
                to enter into this agreement.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">3. Use of Website</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                You agree to use the Website only for lawful purposes and in a way that does not 
                infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the Website.
              </p>
              <p className="text-dark-muted leading-relaxed mb-4">You agree not to:</p>
              <ul className="list-disc list-inside text-dark-muted space-y-2 mb-4">
                <li>Use the Website in any way that violates applicable laws or regulations</li>
                <li>Attempt to gain unauthorized access to any part of the Website</li>
                <li>Transmit any viruses, malware, or other harmful code</li>
                <li>Collect or harvest any information from the Website</li>
                <li>Use automated systems to access the Website without permission</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">4. Content and Information</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                The information on this Website is provided for general informational purposes only. 
                While we strive to provide accurate and up-to-date information, we make no representations 
                or warranties of any kind, express or implied, about the completeness, accuracy, reliability, 
                or suitability of the information.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">5. Casino Offers and Bonuses</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                We provide information about casino offers and bonuses for informational purposes only. 
                Casino offers are subject to change at any time without notice. We are not responsible 
                for the terms and conditions of any casino offers, and you should verify all details 
                directly with the casino before signing up.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">6. Affiliate Relationships</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                GameObsidian may receive compensation from casinos when you click on links or sign up 
                through our website. This does not affect our editorial independence or the accuracy 
                of our reviews.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">7. Intellectual Property</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                All content on this Website, including text, graphics, logos, images, and software, 
                is the property of GameObsidian or its content suppliers and is protected by copyright 
                and other intellectual property laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">8. Limitation of Liability</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                To the fullest extent permitted by law, GameObsidian shall not be liable for any indirect, 
                incidental, special, consequential, or punitive damages, or any loss of profits or revenues, 
                whether incurred directly or indirectly, or any loss of data, use, goodwill, or other 
                intangible losses resulting from your use of the Website.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">9. Responsible Gambling</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                We promote responsible gambling. If you feel that gambling is becoming a problem, 
                please seek help from organizations such as BeGambleAware, GamCare, or Gambling Therapy. 
                We are not responsible for any losses incurred through gambling.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">10. External Links</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                Our Website may contain links to external websites. We are not responsible for the 
                content, privacy policies, or practices of any third-party websites. You access these 
                sites at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">11. Changes to Terms</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                We reserve the right to modify these terms at any time. Your continued use of the 
                Website after any changes constitutes your acceptance of the new terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">12. Governing Law</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                These terms shall be governed by and construed in accordance with the laws of the 
                United Kingdom, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">13. Contact Information</h2>
              <p className="text-dark-muted leading-relaxed">
                If you have any questions about these Terms & Conditions, please contact us at:{' '}
                <a
                  href="mailto:legal@gameobsidian.com"
                  className="text-accent-primary hover:text-accent-secondary transition-colors"
                >
                  legal@gameobsidian.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;

